// ============= Imports =============
import React from 'react';
import { FiStar } from 'react-icons/fi';
import { VISUAL_PROMPT_MESSAGES } from '@/constants/visualPrompts/messages';
import { StarButton } from './styles';

export interface FeaturedStarButtonProps {
  isFeatured: boolean;
  onToggle: () => void;
  disabled?: boolean;
}

// ============= Component =============
export const FeaturedStarButton: React.FC<FeaturedStarButtonProps> = ({
  isFeatured,
  onToggle,
  disabled = false,
}) => (
  <StarButton
    type="button"
    $featured={isFeatured}
    disabled={disabled}
    aria-label={
      isFeatured
        ? VISUAL_PROMPT_MESSAGES.removeFromQuickAccess
        : VISUAL_PROMPT_MESSAGES.addToQuickAccess
    }
    aria-pressed={isFeatured}
    onClick={(e) => {
      e.stopPropagation();
      if (!disabled) {
        onToggle();
      }
    }}
  >
    <FiStar fill={isFeatured ? 'currentColor' : 'none'} size={16} />
  </StarButton>
);
